import type { Card } from '@/types';

export function getReferenceCardProps(
    card: Card,
    { hideReadMoreLabel }: { hideReadMoreLabel?: boolean },
) {
    if (card.contentType === 'casestudies') {
        return {
            path: card.path,
            image: card.media,
            title: card.title,
            readMoreLabel: hideReadMoreLabel ? undefined : 'Read more',
        };
    }

    if (card.contentType === 'examples') {
        return {
            path: card.path,
            image: card.screenshot,
            title: card.title,
            readMoreLabel: hideReadMoreLabel ? undefined : 'See example',
            imageEffects: { scaleCrop: { height: 1200, width: 1920 } },
        };
    }

    if (card.contentType === 'pages') {
        return {
            path: card.path,
            image: card.meta?.image,
            title: card.title ?? card.meta?.title ?? '',
            description: card.meta?.description,
            readMoreLabel: hideReadMoreLabel ? undefined : 'Read more',
        };
    }

    if (card.contentType === 'stories') {
        const category = card.categories?.[0];
        const readMoreLabel = card.site === 'changelog' ? 'Read more' : 'Read article';

        return {
            chipText: card.site === 'changelog' ? 'Changelog' : category?.title,
            path: card.path,
            image: card.meta?.image ?? card.previewImage ?? card.headerImage,
            title: card.title ?? '',
            readMoreLabel: hideReadMoreLabel ? undefined : readMoreLabel,
        };
    }

    if (card.contentType === 'round-tables') {
        return {
            chipText: `Episode ${card.episodeNumber}`,
            path: card.path,
            image: card.image,
            title: card.title,
            readMoreLabel: hideReadMoreLabel ? undefined : 'More details',
            readMoreUrl: card.path,
        };
    }

    throw new Error(`Card type not handled`);
}
